import type { OrganizationProducts } from "@api/private/getOrganization";

type AccessoryCategory = "sspAccessory" | "rrpAccessory" | "focusAccessory" | "accessory";

/**
 * Maps organization products with "paid" status to their corresponding accessory categories.
 * - SKUs containing "ssp" -> sspAccessory
 * - SKUs containing "rrp" -> rrpAccessory
 * - SKUs containing "focus" or "ils" -> focusAccessory
 * - "accessory" is always included for authenticated users
 */
export function getAccessoryCategoriesFromProducts(
  organizationProducts: OrganizationProducts,
): AccessoryCategory[] {
  const categories = new Set<AccessoryCategory>();

  // Always include generic accessory category
  categories.add("accessory");

  for (const [sku, productStatus] of Object.entries(organizationProducts)) {
    if (productStatus.status !== "paid") {
      continue;
    }

    const skuLower = sku.toLowerCase();

    if (skuLower.includes("ssp")) {
      categories.add("sspAccessory");
    }

    // rrp is currently has the same accessories as ssp
    if (skuLower.includes("rrp")) {
      categories.add("sspAccessory");
    }
    if (skuLower.includes("focus") || skuLower.includes("ils")) {
      categories.add("focusAccessory");
    }
  }

  console.log("organizationProducts", categories);

  return Array.from(categories);
}
